// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-icon {\n  display: none;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 3;\n  margin: -0.4rem 0 0 -0.4rem;\n  width: 0.8rem;\n  height: 0.8rem;\n}", ""]);
// Exports
module.exports = exports;
